import Image from "next/image";
import { Log, Status } from '../../lib/definitions'
import { getLevelText, getLowLevelByRating } from '../../lib/utils'

import styles from './page.module.css'

type Props = {
  logs: Log[]
  rating: number
}
const SuccessRate = ({ logs, rating }: Props) => {
  const lowLevel = Math.max(getLowLevelByRating(rating), 1)
  const highLevel = Math.min(lowLevel + 4, 30)

  const successCounts = logs.reduce((acc, log) => {
    if (log.status === Status.ACCEPTED && lowLevel <= log.problemLevel && log.problemLevel <= highLevel) {
      return [...acc].map((count, index) => {
        return index === log.problemLevel - lowLevel ? count + 1 : count
      })
    }
    return acc
  }, new Array(highLevel - lowLevel + 1).fill(0))
  const failCounts = logs.reduce((acc, log) => {
    if (log.status === Status.PASSED && lowLevel <= log.problemLevel && log.problemLevel <= highLevel) {
      return [...acc].map((count, index) => {
        return index === log.problemLevel - lowLevel ? count + 1 : count
      })
    }
    return acc
  }, new Array(highLevel - lowLevel + 1).fill(0))

  const totalResult = new Array(highLevel - lowLevel + 1).fill(0).map((_, index) => {
    return {
      id: index + lowLevel,
      successCounts: successCounts[index],
      failCounts: failCounts[index]
    }
  })

  return (
    <div className={styles.successRate}>
      {totalResult.map(({ id, successCounts, failCounts }, index) => {
        const successRate = successCounts / (successCounts + failCounts)
        return (
          <div key={id} className={styles.successRateItem}>
            <Image src={`https://static.solved.ac/tier_small/${index + lowLevel}.svg`} width={20} height={20} alt="level" />
            <p className={styles.level}>{getLevelText(index + lowLevel)}</p>
            <p className={styles.rate}>{(successCounts + failCounts) === 0 ? '-' : `${(successRate * 100).toFixed(2)}%`}</p>
            <p className={styles.count}>{`${successCounts} / ${successCounts + failCounts}`}</p>
          </div>
        )
      })}
    </div>
  )
}

export default SuccessRate